import {Text} from '@chakra-ui/react';
import {Flex} from '@chakra-ui/layout';
import React from 'react';
import {useModalContext, ModalTypes} from '..';

export const Header = (): JSX.Element => {
  const {type} = useModalContext();

  const content: Record<ModalTypes, any> = {
    share: {},
    redeem: {
      title: 'Gift code created!',
      body: 'We’ve sent you an email with the gift card you can forward on. Alternatively, print off the gift card in the email and give it to them yourself!',
    },
    certificate: {},
    wallet: {},
    deed: {},
  };

  return (
    <Flex
      flex={1}
      margin={{base: '4% 0% 8% 0%', md: '4% 10% 8% 10%'}}
      justifyContent="center"
    >
      <Flex flexDirection="column">
        <Text textStyle="h5" color="white" textAlign="center" mb="2%">
          {content[type].title}
        </Text>
        <Text
          textStyle={{base: 'h7', md: 'h6'}}
          color="white"
          width={{md: '40ch'}}
        >
          {content[type].body}
        </Text>
      </Flex>
    </Flex>
  );
};
